import { render, staticRenderFns } from "./ListOntologies.vue?vue&type=template&id=3b561a0c&scoped=true&"
import script from "./ListOntologies.vue?vue&type=script&lang=js&"
export * from "./ListOntologies.vue?vue&type=script&lang=js&"
import style0 from "./ListOntologies.vue?vue&type=style&index=0&id=3b561a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b561a0c",
  null
  
)

export default component.exports